<template>
  <v-tab v-if="tabDetails.items.length === 1"
         :key="tabDetails.label as string"
         :data-cy="`tab-${tabDetails.id}`"
         :hide-slider="$device.isMobile"
         @click="() => onSelectedTabChange(tabDetails.items[0],tabDetails.id)"
         class="text-none text-subtitle-1"
         :value="tabDetails.id">
    <template #prepend>
      <v-icon :icon="tabDetails.icon" size="x-large"/>
    </template>
    {{ tabDetails.label }}
    <template v-if="tabDetails.id=='action-plan'" #append>
      <ActionsStatusInfo :actions-status="tabDetails.notif"/>
    </template>
  </v-tab>
  <AtomsDefaultHeaderMenu v-else
                          :items="tabDetails.items"
                          :original-tab="tabDetails.id"
                          :alert-is-disabled="alertIsDisabled"
                          :on-selected-tab-change="onSelectedTabChange">
    <template #activator>
      <v-tab
          :key="tabDetails.label as string"
          class="text-none text-subtitle-1"
          :value="tabDetails.id">
        <template #prepend>
          <v-icon :icon="tabDetails.icon" size="x-large"/>
        </template>
        {{ tabDetails.label as string }}
      </v-tab>
    </template>
  </AtomsDefaultHeaderMenu>
</template>
<script setup lang="ts">
import type {MenuItem, OriginalTab, TabDetails} from "~/types/Tab"
import ActionsStatusInfo from "~/components/atoms/diagnostic/ActionsStatusInfo.vue";

defineProps<{
  tabDetails: TabDetails
  alertIsDisabled: (item: MenuItem) => boolean
  onSelectedTabChange: (item: MenuItem, originalTab: OriginalTab) => Promise<void>
}>()
</script>
